import ActionType from 'actions/ActionType'

export default (state = '', action) => {
  switch (action.type) {
    case ActionType.Tasks.CHANGE_FROM_NAME:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action?.payload?.send_email?.trigger_data?.from_name) {
        return action?.payload?.send_email?.trigger_data?.from_name
      }
      return ''
    default:
      return state
  }
}
